import { render, staticRenderFns } from "./k-icon-tooltip.vue?vue&type=template&id=4e40ba60&scoped=true"
import script from "./k-icon-tooltip.vue?vue&type=script&lang=js"
export * from "./k-icon-tooltip.vue?vue&type=script&lang=js"
import style0 from "./k-icon-tooltip.vue?vue&type=style&index=0&id=4e40ba60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e40ba60",
  null
  
)

export default component.exports